import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa024642"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "create-job-template-form",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "templateWrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create Job Template", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("p", null, " This is a predefined blueprint for a job that is expected to be repeated. Creating a new job from a job template will keep a link to the original template, which helps in maintaining a standard process and makes job creation more efficient. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateName" }, [
  /*#__PURE__*/_createTextVNode("Template Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "templateDesc" }, [
  /*#__PURE__*/_createTextVNode("Template Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "partReference" }, [
  /*#__PURE__*/_createTextVNode("Part Reference"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary create-jobtemplate-btn",
    type: "submit"
  }, "Save")
], -1))

import { ref } from 'vue';
import { postToUrl } from '@/api/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateJobTemplate',
  setup(__props) {

const jobTemplate = ref({
  name: '',
  description: '',
  part_reference: '',

});

const resetForm = () => {
  jobTemplate.value = {
    name: '',
    description: '',
    part_reference: '',
  };
};

const saveJobTemplate = async () => {
  try {
    const response = await postToUrl('/ops/api/jobtemplates/', jobTemplate.value);
    alert("Job Template created successfully!");
    resetForm();
  } catch (error) {
    // console.error("Error creating job template:", error);
    alert("Failed to create Job Template. Please check the data and try again.");
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("form", {
        onSubmit: _withModifiers(saveJobTemplate, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            id: "templateName",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jobTemplate.value.name) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, jobTemplate.value.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("textarea", {
            id: "templateDesc",
            cols: "30",
            rows: "5",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((jobTemplate.value.description) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, jobTemplate.value.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            id: "partReference",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((jobTemplate.value.part_reference) = $event)),
            type: "text",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              jobTemplate.value.part_reference,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _hoisted_14
      ], 32)
    ])
  ]))
}
}

})